// @flow
export {
  default,
} from 'web-ssr/app/app-directory/components/AppAlternativesOverview/Container';
